<template>
  <el-col :span="24" :class="'mt-' + spaceBetween + ' mb-' + spaceBetween">
    <hr>
  </el-col>
</template>

<script>
export default {
  name: 'LineSeparator',
  props: {
    spaceBetween: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style lang="scss" scoped>
hr {
  color: white;
}
</style>
